module.exports = __webpack_public_path__ + "static/media/game_quest_mobile_en.07bd379a.png";